<div class="card-container ability"
  [ngClass]="{'fh' : settingsManager.settings.theme == 'fh', 'bb': settingsManager.settings.theme == 'bb', 'expand' : flipped || ability && ability.revealed}"
  [style.--ghs-ability-color]="character && character.color">
  <div class="card" [ngClass]="{'flipped' : flipped || ability && ability.revealed}" card-reveal
    (change)="onChange($event)" [disabled]="!reveal || !ability" #card [style.fontSize]="fontsize">
    <div class=" card-back ability-back"
      [ngClass]="{'bottom-actions' : ability && ability.bottomActions && ability.bottomActions.length > 0 && !character, 'character-actions' : character}">
      <div class="touch"></div>
      <span class="revealed"><span class="text" [ghs-label]="'game.cards.confirmReveal'"></span></span>
      <span class="name" *ngIf="!!monster" [ghs-label]="deckLabel"></span>
      <span class="name" *ngIf="!!character"><span
          [ghs-label]="'data.character.'+ character.edition + '.' + character.name"></span></span>
      <span class="logo" *ngIf="!!character"><img [src]="character.iconUrl" /></span>
    </div>
    <div class="card-front ability-front"
      [ngClass]="{'bottom-actions' : ability && ability.bottomActions && ability.bottomActions.length > 0 && !character, 'character-actions' : character}">
      <ng-container *ngIf="!!ability">
        <div class="initiative"><span *ngIf="ability.initiative < 10">0</span>{{ability.initiative}}</div>
        <span class="name">{{abilityLabel}}</span>
        <div class="ability-actions-container" [ngClass]="{'disabled': activeActions && activeActions == 'bottom'}">
          <div class="ability-actions">
            <ghs-actions [actions]="ability.actions" [monster]="monster" [character]="character"
              [statsCalculation]="statsCalculation" [relative]="relative" [interactiveAbilities]="interactiveAbilities"
              [interactiveActions]="interactiveActions" (interactiveActionsChange)="onInteractiveActionsChange($event)"
              [cardId]="ability.cardId">
            </ghs-actions>
          </div>
          <div class="bottom-spacer"
            *ngIf="interactiveActions.length || settingsManager.settings.interactiveAbilities && settingsManager.settings.showExpandedAbilityCard">
          </div>
        </div>
        <ghs-interactive-actions
          [ngClass]="{'interactive-actions-top' : ability.bottomActions && ability.bottomActions.length > 0 || character}"
          *ngIf="interactiveAbilities && !!monster && (!activeActions || activeActions && activeActions == 'top')" [figure]="monster"
          [actions]="ability.actions" [(interactiveActions)]="interactiveActions"></ghs-interactive-actions>

        <ng-container *ngIf="!!ability.bottomActions && ability.bottomActions.length > 0 || character">
          <span class="level">
            <span class="text" [ghs-label]="ability.level || 0"></span>
          </span>
          <div class="ability-actions-container" [ngClass]="{'disabled': activeActions && activeActions == 'top'}">
            <div class="ability-actions ability-bottom-actions">
              <ghs-actions [actions]="ability.bottomActions" [monster]="monster" [character]="character"
                [statsCalculation]="statsCalculation" [relative]="relative"
                [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveBottomActions"
                (interactiveActionsChange)="onInteractiveBottomActionsChange($event)" [index]="'bottom'"
                [cardId]="ability.cardId">
              </ghs-actions>
            </div>
          </div>

          <ghs-interactive-actions class="interactive-actions-bottom"
            *ngIf="interactiveAbilities && !!monster  && (!activeActions || activeActions && activeActions == 'bottom')" [figure]="monster"
            [actions]="ability.bottomActions" [(interactiveActions)]="interactiveBottomActions"
            [preIndex]="'bottom'"></ghs-interactive-actions>
        </ng-container>
        <div class="shuffle" *ngIf="ability.shuffle"><img src="./assets/images/shuffle.svg"></div>
        <div class="bottom-shuffle" *ngIf="ability.bottomShuffle"><img src="./assets/images/shuffle.svg"></div>
        <span class="index" *ngIf="!ability.cardId && settingsManager.settings.abilityNumbers">[{{abilityIndex +
          1}}]</span>
        <span class="index" *ngIf="ability.cardId && settingsManager.settings.abilityNumbers">
          <span *ngIf="!!character && ability.cardId < 100">0</span>
          <span *ngIf="!!character && ability.cardId < 10">0</span>
          <span>{{ability.cardId}}</span>
        </span>
        <span class="logo" *ngIf="!!character"><img [src]="character.iconUrl" /></span>
        <div class="required-container"
          *ngIf="ability.lost || ability.persistent || ability.loss || ability.round || ability.xp">
          <span class="label">!</span>
          <div class="box">
            <span class="xp" *ngIf="ability.xp">
              <img src="./assets/images/action/card/experience.svg">
              <span class="value">{{ability.xp}}</span>
            </span>
            <span class="persistent" *ngIf="ability.persistent">
              <img src="./assets/images/action/card/persistent.svg">
              <img class="overlay" src="./assets/images/action/card/overlay/persistent.svg">
            </span>
            <span class="loss" *ngIf="ability.loss">
              <img src="./assets/images/action/card/loss.svg">
              <img class="overlay" src="./assets/images/action/card/overlay/loss.svg">
            </span>
            <span class="round" *ngIf="ability.round">
              <img src="./assets/images/action/card/round.svg">
              <img class="overlay" src="./assets/images/action/card/overlay/round.svg">
            </span>
            <span class="lost" *ngIf="ability.lost">
              <img src="./assets/images/action/card/lost.svg">
              <img class="overlay" src="./assets/images/action/card/overlay/lost.svg">
            </span>
          </div>
        </div>
        <div class="required-container bottom"
          *ngIf="ability.bottomLost || ability.bottomPersistent || ability.bottomLoss || ability.bottomRound || ability.bottomXp">
          <span class="label">!</span>
          <div class="box">
            <span class="xp" *ngIf="ability.bottomXp">
              <img src="./assets/images/action/card/experience.svg">
              <span class="value">{{ability.bottomXp}}</span>
            </span>
            <span class="persistent" *ngIf="ability.bottomPersistent">
              <img src="./assets/images/action/card/persistent.svg">
              <img class="overlay" src="./assets/images/action/card/overlay/persistent.svg">
            </span>
            <span class="loss" *ngIf="ability.bottomLoss">
              <img src="./assets/images/action/card/loss.svg">
              <img class="overlay" src="./assets/images/action/card/overlay/loss.svg">
            </span>
            <span class="round" *ngIf="ability.bottomRound">
              <img src="./assets/images/action/card/round.svg">
              <img class="overlay" src="./assets/images/action/card/overlay/round.svg">
            </span>
            <span class="lost" *ngIf="ability.bottomLost">
              <img src="./assets/images/action/card/lost.svg">
              <img class="overlay" src="./assets/images/action/card/overlay/lost.svg">
            </span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>